import AsyncLoader from 'commons/components/AsyncLoader';

export * from './constants';
export { contentSettingsRoute } from './routes';
export default AsyncLoader(() => import('./ContentSettingsLayout'), { loading: () => null });
